export const tr = {
    active: 'Veri toplanıyor...',
    'active-grid': 'Veri toplama',
    'and-grid': 've',
    'budget-grid': 'bütçe',
    completed: 'Anket tamamlandı.',
    'completed-grid': 'Bitti',
    'coverage-grid': 'kapsam',
    draft: 'Taslaktır.',
    'draft-grid': 'Taslak',
    'low-grid': '{reason} yetersiz',
    moderation: 'Moderasyona gönderildi.',
    'moderation-grid': 'Moderasyonda',
    'not-brand-grid': 'araştırılan marka anlaşılmıyor',
    reject: 'Araştırma moderasyon sonucunda reddedildi.',
    'reject-grid': 'Moderasyon sonucunda reddedildi',
    'show-params-grid': 'parametreleri görüntüle',
    'show-result-grid': 'sonuçlar ulaştı',
    stop: 'Anket durduruldu.',
    'stop-grid': 'Durduruldu'
};
